import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.urlValue) return
    setTimeout(() => {
      if (window.top !== window.self) {
        window.top.location.href = this.urlValue
      } else if (window.Turbo) {
        Turbo.visit(this.urlValue, { action: "replace" })
      } else {
        window.location.href = this.urlValue
      }
    }, 10)
  }
}